import { merge, delay } from 'rxjs';
import { map } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { generateCoreSymbolRoute } from '@cbridge-packages/routing-client-admin';
import { SymbolAction } from '@cbridge-packages/symbol';

export const toggleViewCoreSymbolSidebarEpic: IEpic = (action$) => merge(
  action$.pipe(
    isTypeOfAndGetPayload(SymbolAction.create.done),
    delay(100),
    map(({ result }) => {
      return RouterAction.replace([generateCoreSymbolRoute(result.symbolId)]);
    }),
  ),
  action$.pipe(
    isTypeOfAndGetPayload(SymbolAction.update.done),
    map(({ params }) => {
      return RouterAction.replace([generateCoreSymbolRoute(params.symbolId)]);
    }),
  ),
);
